import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Image from "mui-image";
import { Box, Dialog, DialogContent } from "@mui/material";
import { useState, useEffect } from "react";

export default function StandardImageList() {
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    fetch("/.netlify/functions/fetchDrive")
      .then((res) => res.json())
      .then((data) => setPhotos(data))
      .catch((err) => console.error(err));
  }, []);

  const handleClickOpen = (image) => {
    setOpen(true);
    setCurrentImage(image);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ImageList variant="masonry" cols={3}>
        {photos.map((image, i) => (
          <ImageListItem key={image}>
            <Box
              sx={{
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            >
              <Image
                key={i}
                src={image.url}
                alt={image.name}
                loading="lazy"
                onClick={() => handleClickOpen(image)}
              />
            </Box>
          </ImageListItem>
        ))}
      </ImageList>
      <Dialog onClose={handleClose} open={open}>
        <DialogContent sx={{ p: 0 }}>
          <Image
            srcSet={currentImage.url}
            src={currentImage.url}
            alt={currentImage.name}
            duration={1000}
            loading="lazy"
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
